import React, { useMemo } from 'react';
import { tenantCredits, usageLogs } from '../../Data/saas/credits';

export default function CreditsPanel({ session }) {
  const tenantPool = useMemo(() => tenantCredits.find(t => t.tenantId === session?.tenantId), [session]);
  const logs = useMemo(() => usageLogs.filter(l => l.tenantId === session?.tenantId && (!session?.userId || l.studentId === session.userId)), [session]);

  if (!session) return null;

  return (
    <div style={{ padding: 16, display: 'grid', gap: 8 }}>
      <h3 style={{ margin: 0 }}>Credits Usage</h3>
      {tenantPool ? (
        <div>
          <div>Total: {tenantPool.totalCredits.toLocaleString()} | Used: {tenantPool.usedCredits.toLocaleString()} | Remaining: {(tenantPool.totalCredits - tenantPool.usedCredits).toLocaleString()}</div>
          <div>Period: {tenantPool.periodStart} → {tenantPool.periodEnd}</div>
        </div>
      ) : (
        <div>No pool found for tenant.</div>
      )}
      <div>
        <strong>Recent usage</strong>
        <ul>
          {logs.slice(-10).reverse().map((l, idx) => (
            <li key={idx}>{l.ts} — {l.appId} — {l.credits} credits — {l.purpose}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}



